"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKInPlaceInput = void 0;
var React = __importStar(require("react"));
var hooks_1 = require("../../common/hooks");
var DisplayModeTemplate_1 = require("./DisplayModeTemplate");
var EditModeTemplate_1 = require("./EditModeTemplate");
require("./GKInPlaceInput.css");
/**
 * Simple component that switches in place between "display" and "edit" modes for a data item.
 */
var GKInPlaceInput = function (props) {
    var mergedProps = (0, hooks_1.useMergedProps)(props, {
        _gkComponentIdentifier: "gk-in-place-input",
    });
    var disabled = mergedProps.disabled, editOnFocus = mergedProps.editOnFocus, value = mergedProps.value, placeholder = mergedProps.placeholder, type = mergedProps.type, onChange = mergedProps.onChange, onInternalChange = mergedProps.onInternalChange, validation = mergedProps.validation, saveButtonText = mergedProps.saveButtonText, saveOnExit = mergedProps.saveOnExit, icon = mergedProps.icon, displayModeIcon = mergedProps.displayModeIcon, editModeIcon = mergedProps.editModeIcon, otherProps = __rest(mergedProps, ["disabled", "editOnFocus", "value", "placeholder", "type", "onChange", "onInternalChange", "validation", "saveButtonText", "saveOnExit", "icon", "displayModeIcon", "editModeIcon"]);
    var passDownProps = {
        disabled: disabled,
        editOnFocus: editOnFocus,
        value: value,
        onInternalChange: onInternalChange,
        placeholder: placeholder,
        saveButtonText: saveButtonText,
        saveOnExit: saveOnExit,
        type: type,
        validation: validation,
        icon: icon,
        displayModeIcon: displayModeIcon,
        editModeIcon: editModeIcon,
    };
    var _a = React.useState(false), isModifying = _a[0], setIsModifying = _a[1];
    var startEditing = function () {
        setIsModifying(true);
    };
    var finishEditing = function (val) {
        setIsModifying(false);
        if (val !== undefined && onChange) {
            onChange(val);
        }
    };
    return (React.createElement("div", __assign({}, otherProps), isModifying && !disabled ? (React.createElement(EditModeTemplate_1.EditModeTemplate, __assign({ onExit: finishEditing }, passDownProps))) : (React.createElement(DisplayModeTemplate_1.DisplayModeTemplate, __assign({ onStart: startEditing }, passDownProps)))));
};
exports.GKInPlaceInput = GKInPlaceInput;
exports.default = exports.GKInPlaceInput;
